import axios from 'utils/axios';
import { put, call } from 'redux-saga/effects';
import * as HitClub from 'actions/HitClub';
import { toastr } from 'react-redux-toastr'
import i18n from 'i18n/i18n.js';
import {format, parseISO, setSeconds, setHours, setMinutes} from "date-fns";
import { sv, enUS } from 'date-fns/esm/locale';

export function* onGetHitClubsMenuRequest({ cb }) {
  try {
    const res = yield axios.get(`/api/hitClub/currentTree`);
    yield put(HitClub.onGetHitClubsMenuSuccess(res.data || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitClubsMenuFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetHitClubRequest({ params, cb }) {
  try {
    const res = yield axios.get(`/api/hitClub/${params.hitClubId}`);
    yield put(HitClub.onGetHitClubSuccess(res.data || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitClubFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetHitClubsRequest({ cb }) {
  try {
    const res = yield axios.get(`/api/hitClub/current2`);
    yield put(HitClub.onGetHitClubsSuccess(res.data || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitClubsFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetHitClubMembersRequest({ payload, cb }) { 
  const { hitClubId, orderBy, orderDirection, page, size, filterHitClubId, filterHitMemberStatus, filterHasApp, q, updateNumberOfMembers } = payload;

  try {
    const res = yield axios.get(`/api/hitClub/v2/${hitClubId}/allHitMembers?page=${page || 0}&size=${size || 10}${!!filterHitClubId ? `&hitClubId=${filterHitClubId}` : ''}${!!filterHitMemberStatus ? `&hitMemberStatuses=${filterHitMemberStatus}` : ''}${typeof filterHasApp !== 'undefined' ? `&hasApp=${filterHasApp}` : ''}${!!q ? `&q=${q}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    //console.log('saga resp', res.data)
    yield put(HitClub.onGetHitClubMembersSuccess({ data: res.data, updateNumberOfMembers: updateNumberOfMembers }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitClubMembersFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitClubMembersRequestsRequest({ payload, cb }) { 
  const { hitClubId, page, size, filterHitClubId, filterHitMemberStatus, filterHasApp, q } = payload;

  try {
    const res = yield axios.get(`/api/hitClub/v2/${hitClubId}/allHitMembers?page=${page || 0}&size=${size || 10}${filterHitClubId ? `&hitClubId=${filterHitClubId}` : ''}${filterHitMemberStatus ? `&hitMemberStatuses=${filterHitMemberStatus}` : ''}${typeof filterHasApp !== 'undefined' ? `&hasApp=${filterHasApp}` : ''}${q ? `&q=${q}` : ''}`);
    //console.log('saga resp', res.data)
    yield put(HitClub.onGetHitClubMembersRequestsSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitClubMembersRequestsFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitClubHitEventRequest({ payload, cb }) { 
  const { hitEventId } = payload;

  try {
    const res = yield axios.get(`/api/hitEvent/${hitEventId}`);
    //console.log('saga resp', res.data)
    yield put(HitClub.onGetHitClubHitEventSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitClubHitEventFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitClubHitEventsRequest({ payload, cb }) { 
  const { hitClubId, page, size, filterHitClubId, filterHitEventType, q, orderBy, orderDirection, fromDate, toDate } = payload;

  console.log(
    'RUNNING', filterHitEventType
  )

  try {
    const res = yield axios.get(`/api/hitClub/v2/${hitClubId}/allHitEvents?page=${page || 0}&size=${size || 10}${filterHitClubId ? `&hitClubId=${filterHitClubId}` : ''}${filterHitEventType ? `&hitEventType=${filterHitEventType}` : ''}${q ? `&q=${q}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    //console.log('saga resp', res.data)
    yield put(HitClub.onGetHitClubHitEventsSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitClubHitEventsFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateHitClubRequest({ params, cb }) {
  try {
      const data = new FormData();
      data.append('hitClubName', params.hitClubName)
      data.append('visible', params.visible)
      data.append('about', params.about)
      data.append('parentHitClubId', params.parentHitClubId)
      data.append('headerLogo', params.headerLogo)
      data.append('logo', params.logo)
      data.append('metadataIds', params.metadataIds)
      data.append('hitClubUserIds', params.hitOwnersIds)
      data.append('instagramName', params.instagramName)
      data.append('companyIds', params.companyIds)
      data.append('membersExclusive', params.membersExclusive)
      data.append('hitNowsRestrictedToAdmins', params.hitNowsRestrictedToAdmins)
      const rs = yield axios.post(`/api/hitClub/createHitClub`, data);
      yield put(HitClub.onCreateHitClubSuccess(rs.data || {}));

      toastr.success(i18n.t('toastr.onCreateHitClubRequest.title'), i18n.t('toastr.onCreateHitClubRequest.body'))

      cb && cb(params, rs.data);
  } catch (e) {
      console.log('Error: onCreateHitClubRequest');
      yield put(HitClub.onCreateHitClubFailure());
      cb && cb(e);
  }
}

export function* onEditHitClubRequest({ params, cb }) {
  try {
      const data = new FormData();
      data.append('hitClubId', params.hitClubId)
      if (params.visible) data.append('visible', params.visible)
      if (!!params.hitClubName) data.append('hitClubName', params.hitClubName)
      if (!!params.about) data.append('about', params.about)
      if (!!params.parentHitClubId) data.append('parentHitClubId', params.parentHitClubId)
      if (!!params.headerLogo) data.append('headerLogo', params.headerLogo)
      if (!!params.logo) data.append('logo', params.logo)
      if (!!params.metadataIds) data.append('metadataIds', params.metadataIds)
      if (!!params.hitOwnersIds) data.append('hitClubUserIds', params.hitOwnersIds)
      if (!!params.instagramName) data.append('instagramName', params.instagramName)
      if (!!params.hitClubMemberSetting) data.append('hitClubMemberSetting', params.hitClubMemberSetting)
      if (!!params.memberParameters) data.append('memberParameters', params.memberParameters)
      if (!!params.companyIds) data.append('companyIds', params.companyIds)
      data.append('membersExclusive', params.membersExclusive)
      const rs = yield axios.post(`/api/hitClub/updateHitClub`, data);
      yield put(HitClub.onEditHitClubSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onEditHitClubSuccess.title'), i18n.t('toastr.onEditHitClubSuccess.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditHitClubRequest');
      yield put(HitClub.onEditHitClubFailure());
      cb && cb(e);
  }
}

export function* onApproveMemberRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/hitClub/updateMemberStatusAndReason`, params);
    yield put(HitClub.onApproveMemberSuccess(res.data || {}));    
    if(res.data.hitMemberStatus === "MEMBER") {
      toastr.success(i18n.t('toastr.onApproveMemberSuccess.member.title'), i18n.t('toastr.onApproveMemberSuccess.member.body', { name: res.data.firstName }))
    }
    else if(res.data.hitMemberStatus === "PENDING_PAYMENT") {
      toastr.success(i18n.t('toastr.onApproveMemberSuccess.pendingPayment.title'), i18n.t('toastr.onApproveMemberSuccess.pendingPayment.body', { name: res.data.firstName }))
    }
    else if(res.data.hitMemberStatus === "PENDING_USER_FEEDBACK") {
      toastr.success(i18n.t('toastr.onApproveMemberSuccess.pendingUserFeedback.title'), i18n.t('toastr.onApproveMemberSuccess.pendingUserFeedback.body', { name: res.data.firstName }))
    }
    else if(res.data.hitMemberStatus === "CANCELLED_DECLINED") {
      toastr.success(i18n.t('toastr.onApproveMemberSuccess.cancelled.title'), i18n.t('toastr.onApproveMemberSuccess.cancelled.body', { name: res.data.firstName }))
    }
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onApproveMemberFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onApproveMembersRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/hitClub/approveMultiple`, params);

    yield put(HitClub.onApproveMembersSuccess(res.data || {}));    

    if(res.data.success.length > 0) {
      toastr.success(i18n.t('toastr.onApproveMembersSuccess.title', { count: res.data.success.length }))
    }
    else if(res.data.error.length > 0) {
      toastr.success(i18n.t('toastr.onApproveMembersFailure.title', { count: res.data.error.length }), i18n.t('toastr.onApproveMembersFailure.body'))
    }
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onApproveMembersFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onCreateHitEventRequest({ params, cb }) {
  try {
      const data = new FormData();
      data.append('hitEventType', params.hitEventType === 'ELECTION' ? 'ELECTION' : 'SOCIAL')
      if (!!params.coverImage) data.append('image', params.coverImage)
      data.append('name', params.hitEventName)
      if (!!params.hitClubId) data.append('hitClubId', params.hitClubId)
      if (!!params.companyId) data.append('companyId', params.companyId)
      if (params.hitEventDescription !== "") data.append('description', params.hitEventDescription)
      data.append('visible', params.visible)

      data.append('eventDate', format(setSeconds(params.fromDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      data.append('eventEndDate', format(setSeconds(params.toDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.hitEventPlace !== "") data.append('eventPlaceDescription', params.hitEventPlace)

      data.append('promoterIds', params.promoters)
      data.append('hobbyIds', params.hitEventHobbies)
      data.append('additionalHitClubIds', params.additionalHitClubIds)
      data.append('additionalCompanyIds', params.additionalCompanyIds)
      data.append('totalNumberOfTickets', params.totalNumberOfTickets)
      data.append('published', params.published)
      if(!!params.publishedDate) {
        data.append('publishedDate', params.publishedDate)
      }
      if (params.hitEventType !== 'ELECTION') data.append('maxOneProductTypeTicketPerUser', params.maxOneProductTypeTicketPerUser)
      
      if (params.membersExclusive !== undefined) data.append('membersExclusive', params.membersExclusive)

      if (params.hitEventType === 'ELECTION' &&  params.electionDate instanceof Date) data.append('electionDate', format(setSeconds(params.electionDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.hitEventType === 'ELECTION' &&  params.electionEndDate instanceof Date) data.append('electionEndDate', format(setSeconds(params.electionEndDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.hitEventType === 'ELECTION') data.append('publishElectionResultInEvent', params.publishElectionResultInEvent)

      if (params.hitEventType !== 'ELECTION') data.append('hitNowsRestrictedToAdmins', params.hitNowsRestrictedToAdmins)

      const rs = yield axios.post(`/api/hitClub/v2/createHitEvent`, data);
      console.log('rs.data', rs.data)
      yield put(HitClub.onCreateHitEventSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onCreateHitEventRequest.title'), i18n.t('toastr.onCreateHitEventRequest.body', { name: params.hitEventName }))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateHitEventRequest', e);
      yield put(HitClub.onCreateHitEventFailure());
      cb && cb(e);
  }
}

export function* onEditHitEventRequest({ params, cb }) {

  try {
      const data = new FormData();

      data.append('hitEventId', params.hitEventId)
      if (!!params.coverImage) data.append('image', params.coverImage)
      if (!!params.hitEventName) data.append('name', params.hitEventName)
      if (!!params.hitEventDescription) data.append('description', params.hitEventDescription)
      if (params.visible !== undefined) data.append('visible', params.visible)
      if (params.fromDate instanceof Date) data.append('eventDate', format(setSeconds(params.fromDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.toDate instanceof Date) data.append('eventEndDate', format(setSeconds(params.toDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (!!params.hitEventPlace && params.hitEventPlace.length > 0) data.append('eventPlaceDescription', params.hitEventPlace)
      if (!!params.promoters && params.promoters.length > 0) data.append('promoterIds', params.promoters)
      if (!!params.hitEventHobbies && params.hitEventHobbies.length > 0) data.append('hobbyIds', params.hitEventHobbies)
      if (!!params.additionalHitClubIds) data.append('additionalHitClubIds', params.additionalHitClubIds)
      if (!!params.additionalCompanyIds) data.append('additionalCompanyIds', params.additionalCompanyIds)
      if (!!params.totalNumberOfTickets) data.append('totalNumberOfTickets', params.totalNumberOfTickets)
      data.append('skipNotification', params?.skipNotification||false)
      data.append('published', params.published)
      if(!!params.publishedDate) {
        data.append('publishedDate', params.publishedDate)
      }
      if (params.maxOneProductTypeTicketPerUser !== undefined) data.append('maxOneProductTypeTicketPerUser', params?.maxOneProductTypeTicketPerUser)

      if (params.membersExclusive !== undefined) data.append('membersExclusive', params.membersExclusive)

      if (params.hitEventType === 'ELECTION' && params.electionDate instanceof Date) data.append('electionDate', format(setSeconds(params.electionDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.hitEventType === 'ELECTION' && params.electionEndDate instanceof Date) data.append('electionEndDate', format(setSeconds(params.electionEndDate, 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}))
      if (params.hitEventType === 'ELECTION') data.append('publishElectionResultInEvent', params.publishElectionResultInEvent)
      if (params.hitNowsRestrictedToAdmins !== undefined) data.append('hitNowsRestrictedToAdmins', params.hitNowsRestrictedToAdmins)

      const rs = yield axios.post(`/api/hitClub/v2/updateHitEvent`, data);
      toastr.success(i18n.t('toastr.onEditHitEventSuccess.title'), i18n.t('toastr.onEditHitEventSuccess.body', { name: params.hitEventName }))
      
      yield put(HitClub.onEditHitEventSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditHitEventRequest');
      yield put(HitClub.onEditHitEventFailure());
      cb && cb(e);
  }
}

export function* onCreateHitClubOwnerRequest({ params, cb }) {
  try {
      const { hitClubId, studentId } = params;
      const rs = yield axios.post(`/api/hitClub/v2/${hitClubId}/addHitClubUser`, params);
      yield put(HitClub.onCreateHitClubOwnerSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onCreateHitClubOwnerRequest.title'), i18n.t('toastr.onCreateHitClubOwnerRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateHitClubOwnerRequest');
      yield put(HitClub.onCreateHitClubOwnerFailure());
      cb && cb(e);
  }
}

export function* onGetHitClubOwnerRequest({ params, cb }) {
  const { hitClubId } = params;
  try {
      const rs = yield axios.get(`/api/hitClub/${hitClubId}/loggedInHitClubUser`);
      yield put(HitClub.onGetHitClubOwnerSuccess(rs.data || {}));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetHitClubOwnerRequest');
      // yield put(HitClub.onGetHitClubOwnerFailure());
      cb && cb(e);
  }
}

export function* onUpdateHitClubOwnerRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/hitClub/hitClubUser/update`, params);
      yield put(HitClub.onUpdateHitClubOwnerSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onUpdateHitClubOwnerRequest.title'), i18n.t('toastr.onUpdateHitClubOwnerRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onUpdateHitClubOwnerRequest');
      yield put(HitClub.onUpdateHitClubOwnerFailure());
      cb && cb(e);
  }
}

export function* onCreateHitClubOwnerOtherRequest({ params, cb }) {
  const { hitClubId, firstName, lastName, email, hitClubUserRole } = params
  try {
      const rs = yield axios.post(`/api/hitClub/${hitClubId}/hitClubUser/createAccount`, { firstName, lastName, email, hitClubUserRole });
      yield put(HitClub.onCreateHitClubOwnerOtherSuccess({ data: rs.data, hitClubId }|| {}));
      toastr.success(i18n.t('toastr.onCreateHitClubOwnerOtherRequest.title'), i18n.t('toastr.onCreateHitClubOwnerOtherRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateHitClubOwnerOtherRequest', e);
      yield put(HitClub.onCreateHitClubOwnerOtherFailure());
      toastr.error(i18n.t('toastr.onCreateHitClubOwnerOtherFailure.title'), i18n.t('toastr.onCreateHitClubOwnerOtherFailure.body'))
      cb && cb(e);
  }
}

export function* onRemoveHitClubOwnerRequest({ params, cb }) {
  try {
      const { hitClubId, studentId } = params;
      const rs = yield axios.delete(`/api/hitClub/${hitClubId}/removeHitClubUser`, {data: {studentId}});
      yield put(HitClub.onRemoveHitClubOwnerSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onRemoveHitClubOwnerRequest.title'), i18n.t('toastr.onRemoveHitClubOwnerRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onRemoveHitClubOwnerRequest');
      yield put(HitClub.onRemoveHitClubOwnerFailure());
      cb && cb(e);
  }
}

export function* onImportMembersRequest({ params, cb }) {
  try {
      const { hitClubId, members, membershipOfferId } = params;

      const membersWithMembershipOfferId = members.map(member => {
        return ({
          ...member,
          membershipOffer: {
            membershipOfferId: membershipOfferId
          }
        })
      })

      const rs = yield axios.post(`/api/hitClub/${hitClubId}/createMembers`, membersWithMembershipOfferId);
      console.log("RES: ",rs.data)

      yield put(HitClub.onImportMembersSuccess({ numberOfCreatedMembers: rs.data.numberOfCreatedMembers, hitClubId: hitClubId } || {}));
      yield call(onGetHitClubMembersRequest, { payload: { hitClubId: hitClubId, updateNumberOfMembers: true, filterHitMemberStatus: 'MEMBER,PAID_NOT_MEMBER' } });
      
      toastr.success(i18n.t('toastr.onImportMembersRequest.title', { importedMembers: rs.data.numberOfCreatedMembers }), i18n.t('toastr.onImportMembersRequest.body', { notImportedMembers: rs.data.numberOfSkippedMembers, updatedMembers: rs.data.numberOfUpdatedMembers }))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onImportMembersRequest', e);
      // yield put(HitClub.onImportMembersFailure());
      cb && cb(e);
  }
}

export function* onSendRemindersToMembersRequest({ params, cb }) {
  try {
      const { hitClubId, members } = params;
      const rs = yield axios.post(`/api/hitClub/${hitClubId}/sendRemindersToMembers`, members);
      toastr.success(i18n.t('toastr.onSendRemindersToMembersRequest.title'), i18n.t('toastr.onSendRemindersToMembersRequest.body', { numberOfMembers: members.length }))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onSendRemindersToMembersRequest', e);
      // yield put(HitClub.onImportMembersFailure());
      cb && cb(e);
  }
}

export function* onSendRemindersToAllRequest({ params, cb }) {
  try {
      const { hitClubId } = params;
      const rs = yield axios.post(`/api/hitClub/${hitClubId}/sendRemindersToAll`);
      toastr.success(i18n.t('toastr.onSendRemindersToAllRequest.title'), i18n.t('toastr.onSendRemindersToAllRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onSendRemindersToMembersRequest', e);
      // yield put(HitClub.onImportMembersFailure());
      cb && cb(e);
  }
}

export function* onEditHitMemberRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/hitClub/updateMember`, params);
    yield put(HitClub.onEditHitMemberSuccess(res.data || {}));
    toastr.success(i18n.t('toastr.onEditHitMemberSuccess.title'), i18n.t('toastr.onEditHitMemberSuccess.body'))
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onEditHitMemberFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onRemoveHitMemberRequest({ params, cb }) {
  const { hitMemberId, cancelledReason } = params
  try {
    const res = yield axios.delete(`/api/hitClub/v2/deleteMember`, {data: {hitMemberId, cancelledReason}});
    yield put(HitClub.onRemoveHitMemberSuccess({ hitMemberId: hitMemberId } || {}));
    toastr.success(i18n.t('toastr.onRemoveHitMemberSuccess.title'), i18n.t('toastr.onRemoveHitMemberSuccess.body'))
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onRemoveHitMemberFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onCreateTicketRequest({ params, cb }) {

  const {
    hitClubId,
    hitEvent,
    name,
    description,
    ticketPlaceDescription,
    totalNumberOfTickets,
    ticketCode,
    ticketHasAPrice,
    maxTicketsPerUser,
    ticketPrice,
    onlyForMembershipOffers,
    ticketDate,
    ticketEndDate,
    ticketTypeType,
    hasCustomStripe,
    stripeText,
    stripeColor,
    shareAble,
    webSales,
    hasQrCode,
    vat,
    shortLivedQrCode
  } = params

  const transformParamsToProduct = {
      "label" : name,
      "productSalesType": ticketTypeType,
      "numberOfProducts" : totalNumberOfTickets,
      "maxProductsPerUser": maxTicketsPerUser,
      "price": ticketHasAPrice ? ticketPrice : 0,
      "memberPrice": 0,
      "productSalesFromDate": ticketDate,
      "productSalesToDate": ticketEndDate,
      "productCode": ticketCode,
      "hasCustomStripe": hasCustomStripe,
      "stripeText": stripeText,
      "stripeColor": stripeColor,
      "onlyForMembershipOffers" : onlyForMembershipOffers,
      "shareAble" : shareAble,
      "entityType": "HIT_EVENT",
      "entityId": hitEvent.hitEventId,
      "productBase" : {
        "name" : name,
        "description" : description,
        "entityType" : "HIT_CLUB",
        "entityId" : hitClubId,
        "productPortfolio" : false,
        "productType": "TICKET",
        "productCategory": "OTHER",
        "logoInput" : null,
        "vat" : vat
      },
      "webSales" : webSales,
      "hasQrCode" : hasQrCode,
      "shortLivedQrCode" : shortLivedQrCode
  }

  try {
      const rs = yield axios.post(`/api/product/createProductOffer`, transformParamsToProduct);
      // console.log("RES: ",rs.data)
      yield put(HitClub.onCreateTicketSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onCreateTicketRequest.title'), i18n.t('toastr.onCreateTicketRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateTicketRequest', e);
      yield put(HitClub.onCreateTicketFailure());
      cb && cb(e);
  }
  // try {
  //     const rs = yield axios.post(`/api/hitClub/v2/createTicketType`, params);
  //     // console.log("RES: ",rs.data)
  //     yield put(HitClub.onCreateTicketSuccess(rs.data || {}));
  //     toastr.success(i18n.t('toastr.onCreateTicketRequest.title'), i18n.t('toastr.onCreateTicketRequest.body'))
  //     cb && cb(null, rs.data);
  // } catch (e) {
  //     console.log('Error: onCreateTicketRequest', e);
  //     yield put(HitClub.onCreateTicketFailure());
  //     cb && cb(e);
  // }
}

export function* onEditTicketRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/product/updateProductOffer`, params);

      yield put(HitClub.onEditTicketSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onEditTicketRequest.title'), i18n.t('toastr.onEditTicketRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditTicketRequest', e);
      yield put(HitClub.onEditTicketFailure());
      cb && cb(e);
  }
}

export function* onGetEditTicketInformationRequest({ params, cb }) {

  const { productOfferId } = params

  try {
      const rs = yield axios.get(`/api/product/offer/${productOfferId}/edit`);

      yield put(HitClub.onGetEditTicketInformationSuccess(rs.data || {}));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetEditTicketInformationRequest', e);
      yield put(HitClub.onGetEditTicketInformationFailure());
      cb && cb(e);
  }
}

export function* onGetTicketQuestionsRequest({ params, cb }) {
  const { dynamicInfoId, hitEventId, productOfferId } = params

  try {
      const rs = yield axios.get(`/api/dynamicInfo2/${dynamicInfoId}`);
      yield put(HitClub.onGetTicketQuestionsSuccess({ data: rs.data, hitEventId: hitEventId, productOfferId: productOfferId } ));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateTicketQuestionsRequest', e);
      yield put(HitClub.onGetTicketQuestionsFailure());
      cb && cb(e);
  }
}

export function* onCreateTicketQuestionsRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/dynamicInfo2/productOffer/${params.productOfferId}/create`, { description: params.description, questions: params.questions });
      yield put(HitClub.onCreateTicketQuestionsSuccess({ data: rs.data || {}, productOfferId: params.productOfferId, hitEventId: params.hitEventId }));
      toastr.success(i18n.t('toastr.onCreateTicketQuestionsRequest.title'), i18n.t('toastr.onCreateTicketQuestionsRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateTicketQuestionsRequest', e);
      yield put(HitClub.onCreateTicketQuestionsFailure());
      cb && cb(e);
  }
}

export function* onDeleteTicketQuestionsRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/dynamicInfo2/productOffer/${params.productOfferId}/delete` );
      yield put(HitClub.onDeleteTicketQuestionsSuccess({ data: rs.data || {}, productOfferId: params.productOfferId, hitEventId: params.hitEventId }));
      toastr.success(i18n.t('toastr.onDeleteTicketQuestionsRequest.title'), i18n.t('toastr.onDeleteTicketQuestionsRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onDeleteTicketQuestionsRequest', e);
      yield put(HitClub.onDeleteTicketQuestionsFailure());
      cb && cb(e);
  }
}

export function* onEditTicketQuestionsRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/dynamicInfo2/update`, { dynamicInfoId: params.dynamicInfoId, description: params.description, questions: params.questions });
      yield put(HitClub.onEditTicketQuestionsSuccess({ data: rs.data || {}, productOfferId: params.productOfferId, hitEventId: params.hitEventId }));
      toastr.success(i18n.t('toastr.onEditTicketQuestionsRequest.title'), i18n.t('toastr.onEditTicketQuestionsRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditTicketQuestionsRequest', e);
      yield put(HitClub.onEditTicketQuestionsFailure());
      cb && cb(e);
  }
}

export function* onRemoveTicketRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/product/offer/delete`, { productOfferId: params.productOfferId });
      yield put(HitClub.onRemoveTicketSuccess({ data: rs.data, params: params } || {}));
      toastr.success(i18n.t('toastr.onDeleteTicketRequest.title'), i18n.t('toastr.onDeleteTicketRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onRemoveTicketRequest', e);
      yield put(HitClub.onRemoveTicketFailure());
      cb && cb(e);
  }
}

export function* onRemoveHitEventRequest({ params, cb }) {
  try {
      const rs = yield axios.delete(`/api/hitClub/deleteHitEvent`, {data: params});
      yield put(HitClub.onRemoveHitEventSuccess({ data: rs.data, params: params } || {}));
      toastr.success(i18n.t('toastr.onRemoveHitEventRequest.title'), i18n.t('toastr.onRemoveHitEventRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onRemoveTicketRequest', e);
      yield put(HitClub.onRemoveHitEventFailure());
      toastr.error(
        i18n.t('toastr.onRemoveHitEventFailure.title'), 
        i18n.t('toastr.onRemoveHitEventFailure.body'),
        { timeOut: 30000 }
        )
      cb && cb(e);
  }
}

export function* onCreateMembershipOfferRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/membership/createMembershipOffer`, params);
      yield put(HitClub.onCreateMembershipOfferSuccess(rs.data || {}));
      toastr.success(i18n.t('toastr.onCreateMembershipOfferRequest.title'), i18n.t('toastr.onCreateMembershipOfferRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onCreateMembershipOfferRequest', e);
      yield put(HitClub.onCreateMembershipOfferFailure());
      cb && cb(e);
  }
}

export function* onEditMembershipOfferRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/membership/update`, params.data);
      yield put(HitClub.onEditMembershipOfferSuccess({ data: rs.data || {}, hitClubId: params.hitClubId }));
      toastr.success(i18n.t('toastr.onEditMembershipOfferRequest.title'), i18n.t('toastr.onEditMembershipOfferRequest.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditMembershipOfferRequest', e);
      yield put(HitClub.onEditMembershipOfferFailure());
      cb && cb(e);
  }
}

export function* onGetEditMembershipOfferRequest({ params, cb }) {
  try {
      const rs = yield axios.get(`/api/membership/${params.membershipOfferId}/edit`);
      yield put(HitClub.onGetEditMembershipOfferSuccess({ data: rs.data || {}, hitClubId: params.hitClubId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onEditMembershipOfferRequest', e);
      yield put(HitClub.onGetEditMembershipOfferFailure());
      cb && cb(e);
  }
}

export function* onDeleteMembershipOfferRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/membership/delete`, params);
      yield put(HitClub.onDeleteMembershipOfferSuccess(params));
      toastr.success(i18n.t('toastr.onDeleteMembershipOfferSuccess.title'), i18n.t('toastr.onDeleteMembershipOfferSuccess.body'))
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onEditMembershipOfferRequest', e);
      yield put(HitClub.onDeleteMembershipOfferFailure());
      cb && cb(e);
  }
}

export function* onConnectInstagramRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/hitClub/connectInstagram`, params);
      yield put(HitClub.onConnectInstagramSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onConnectInstagramRequest', e);
      yield put(HitClub.onConnectInstagramFailure());
      cb && cb(e);
  }
}

export function* onDeleteInstagramRequest({ params, cb }) {
  try {
      const rs = yield axios.delete(`/api/hitClub/deleteInstagram`, {data: params});
      yield put(HitClub.onDeleteInstagramSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onDeleteInstagramRequest', e);
      yield put(HitClub.onDeleteInstagramFailure());
      cb && cb(e);
  }
}

export function* onGetHitClubMemberLogRequest({ params, cb }) {
  const { hitMemberId, page, size, orderBy, orderDirection } = params;

  try {
      // const rs = yield axios.get(`/api/event/get?entityType=HIT_MEMBER&entityId=${hitMemberId}&page=${page || 0}&size=${size || 10}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
      const rs = yield axios.get(`/api/hitMember/${hitMemberId}/versions?page=${page || 0}&size=${size || 10}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
      yield put(HitClub.onGetHitClubMemberLogSuccess( { data: (rs.data || {}), hitMemberId: hitMemberId } ));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onGetHitClubMemberLogRequest', e);
      yield put(HitClub.onGetHitClubMemberLogFailure());
      cb && cb(e);
  }
}

export function* onUploadAdmissionFileRequest({ params, cb }) {
  const { hitClubId, file } = params;
  
  try {

      const data = new FormData();
      data.append('file', file)

      const rs = yield axios.post(`/api/hitClub/${hitClubId}/uploadAdmissionFile`, data);
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onImportMembersRequest', e);
      // yield put(HitClub.onUploadAdmissionFileFailure());
      cb && cb(e);
  }
}

export function* onUploadRegistrationFileRequest({ params, cb }) {
  const { hitClubId, file } = params;
  
  try {

      const data = new FormData();
      data.append('file', file)

      const rs = yield axios.post(`/api/hitClub/${hitClubId}/uploadRegistrationFile`, data);
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onImportMembersRequest', e);
      // yield put(HitClub.onUploadAdmissionFileFailure());
      cb && cb(e);
  }
}

export function* onAddMemberRequest({ params, cb }) {  
  console.log('params', params)
  try {
      const rs = yield axios.post(`/api/hitClub/manualBecomeMember`, params);
      yield put(HitClub.onAddMemberSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onAddMemberRequest', e);
      yield put(HitClub.onAddMemberFailure());
      cb && cb(e);
  }
}

export function* onGetHitClubFeedRequest({ params, cb }) {
  try {
    const res = yield axios.get(`/api/hitClub/web/feed/posts/${params.hitClubId}`);
    yield put(HitClub.onGetHitClubFeedSuccess({ data: res.data, hitClubId: params.hitClubId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitClubFeedFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetHitEventFeedRequest({ params, cb }) {
  try {
    const res = yield axios.get(`/api/hitClub/feed/posts/hitEvent/${params.hitEventId}`);
    yield put(HitClub.onGetHitEventFeedSuccess({ data: res.data, hitEventId: params.hitEventId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitEventFeedFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onDeleteStudentPostRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/studentPost/delete`, params.request);
    yield put(HitClub.onDeleteStudentPostSuccess({ data: res.data, hitClubId: params.hitClubId, hitEventId: params.hitEventId, studentPostId: params.request.studentPostId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onDeleteStudentPostFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onCreateStudentPostRequest({ params, cb }) {
  try {

    const data = new FormData();
    data.append('caption', params.caption)
    params.image !== null && data.append('image', params.image)
    data.append('hobbyIds', params.hobbyIds)
    if(!!params.hitClubId) data.append('hitClubId', params.hitClubId)
    if(!!params.hitEventId) data.append('hitEventId', params.hitEventId)
    data.append('fromAdmin', true)
    data.append('published', params.published)
    data.append('publishedDate', params.publishedDate)

    const res = yield axios.post(`/api/studentPost/createStudentPost`, data);
    yield put(HitClub.onCreateStudentPostSuccess({ data: res.data, hitClubId: params.hitClubId, hitEventId: params.hitEventId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onCreateStudentPostFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onEditStudentPostRequest({ params, cb }) {
  try {

    const data = new FormData();
    data.append('studentPostId', params.studentPostId)
    data.append('caption', params.caption)
    params.image !== null && data.append('image', params.image)
    data.append('hobbyIds', params.hobbyIds)
    data.append('fromAdmin', true)
    data.append('published', params.published)
    data.append('publishedDate', params.publishedDate)

    const res = yield axios.post(`/api/studentPost/updateStudentPost`, data);
    yield put(HitClub.onEditStudentPostSuccess({ data: res.data, hitClubId: params.hitClubId, hitEventId: params.hitEventId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onEditStudentPostFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onUpdateMemberStatusRequest({ params, cb }) {
  const { hitMemberId, cancelledReason, hitMemberStatus } = params
  try {
    const res = yield axios.post(`/api/hitClub/updateMemberStatusAndReason`, params);
    yield put(HitClub.onUpdateMemberStatusSuccess(res.data || {}));
    if(hitMemberStatus === "CANCELLED_BANNED") {
      toastr.success(i18n.t('toastr.onUpdateMemberStatusSuccess.title'), i18n.t('toastr.onUpdateMemberStatusSuccess.body'))
    }
    else if(hitMemberStatus === "CANCELLED_TERMINATED_BY_HITCLUB") {
      toastr.success(i18n.t('toastr.onRemoveHitMemberSuccess.title'), i18n.t('toastr.onRemoveHitMemberSuccess.body'))
    }
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onUpdateMemberStatusFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetParametersEditHitEventRequest({ params, cb }) {  
  try {
      const rs = yield axios.get(`/api/hitClub/editHitEventDataExtended/${params.hitEventId}`);
      yield put(HitClub.onGetParametersEditHitEventSuccess( { data: rs.data, hitEventId: params.hitEventId } || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onGetParametersEditHitEventRequest', e);
      yield put(HitClub.onGetParametersEditHitEventFailure());
      cb && cb(e);
  }
}

export function* onGetParametersCreateTicketRequest({ params, cb }) {  
  try {
      const rs = yield axios.get(`/api/product/createProductOfferData?entityType=${params.entityType}&entityId=${params.entityId}`);
      yield put(HitClub.onGetParametersCreateTicketSuccess( { data: rs.data, ticketTypeId: params.ticketTypeId, hitEventId: params.entityId } || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onGetParametersCreateTicketRequest', e);
      yield put(HitClub.onGetParametersCreateTicketFailure());
      cb && cb(e);
  }
}

export function* onGetParametersEditTicketRequest({ params, cb }) {  
  try {
      const rs = yield axios.get(`/api/hitClub/editTicketTypeData/${params.ticketTypeId}`);
      // yield put(HitClub.onGetParametersEditTicketSuccess( { data: rs.data, ticketTypeId: params.ticketTypeId, hitEventId: params.hitEventId } || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onGetParametersEditTicketRequest', e);
      // yield put(HitClub.onGetParametersEditTicketFailure());
      cb && cb(e);
  }
}

export function* onDeleteInstagramPostRequest({ params, cb }) {
  try {
    const res = yield axios.delete(`/api/hitClub/instagram/delete`,{data: {instagramPostId: params.instagramPostId}});
    yield put(HitClub.onDeleteInstagramPostSuccess({ data: res.data, hitClubId: params.hitClubId, hitEventId: params.hitEventId, instagramPostId: params.instagramPostId } || {}));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onDeleteInstagramPostFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onCreateSalesReportRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/transaction/excel`, {
      fromDate: format(setHours(setMinutes(setSeconds(params.fromDate, 0), 0), 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}),
      toDate: params.toDate != null ? format(setHours(setMinutes(setSeconds(params.toDate, 59), 59), 23), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}) : null,
      hitClubId: params.hitClubId
    }, {responseType:'blob'});

    if(!res.data.size) {
      toastr.success(i18n.t('toastr.onCreateSalesReportSuccess.title'), i18n.t('toastr.onCreateSalesReportSuccess.body'))
    } 
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onCreateSalesReportFailure({ message: e.toString(), error: e }));
    toastr.error(i18n.t('toastr.onCreateSalesReportFailure.title'), i18n.t('toastr.onCreateSalesReportFailure.body'))
    cb && cb(e);
  }
}

export function* onCreatePayoutReportRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/hitPayments/${params.hitClubId}/paymentReport`, {
      fromDate: format(setHours(setSeconds(params.fromDate, 0), 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}),
      toDate: params.toDate != null ? format(setHours(setSeconds(params.toDate, 0), 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}) : null
    },{responseType:'blob'});
    if(!res.data.size) {
      toastr.success(i18n.t('toastr.onCreateSalesReportSuccess.title'), i18n.t('toastr.onCreateSalesReportSuccess.body'))
    } 
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onCreatePayoutReportFailure({ message: e.toString(), error: e }));
    toastr.error(i18n.t('toastr.onCreatePayoutReportFailure.title'), i18n.t('toastr.onCreatePayoutReportFailure.body'))
    cb && cb(e);
  }
}

export function* onGetHitClubProductBaseRequest({ payload, cb }) { 
  const { hitProductId } = payload;

  try {
    const res = yield axios.get(`/api/hitProduct/${hitProductId}`);
    yield put(HitClub.onGetHitClubProductBaseSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitClubProductBaseFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitClubProductBasesRequest({ payload, cb }) { 
  const { hitClubId, productPortfolio, page, size, filterHitClubId, q, orderBy, orderDirection, fromDate, toDate } = payload;

  try {
    const res = yield axios.get(`/api/product/base?entityType=HIT_CLUB&entityId=${hitClubId}&productPortfolio=${productPortfolio}&page=${page || 0}&size=${size || 10}${filterHitClubId ? `&hitClubId=${filterHitClubId}` : ''}${q ? `&q=${q}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    yield put(HitClub.onGetHitClubProductBasesSuccess(res.data));

    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitClubProductBasesFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateHitClubProductBaseRequest({ payload, cb }) { 
  try {
    const res = yield axios.post(`/api/product/createProductBase`, payload);
    yield put(HitClub.onCreateHitClubProductBaseSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onCreateHitClubProductBaseFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onUpdateHitClubProductBaseRequest({ payload, cb }) { 

  try {
    const res = yield axios.post(`/api/product/updateProductBase`, payload);
    yield put(HitClub.onUpdateHitClubProductBaseSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onUpdateHitClubProductBaseFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onRemoveHitClubProductBaseRequest({ payload, cb }) { 
  console.log('RUNNING onRemoveHitClubProductBaseRequest', payload)
  try {
    const res = yield axios.post(`/api/product/base/delete`, payload);
    yield put(HitClub.onRemoveHitClubProductBaseSuccess(payload));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onRemoveHitClubProductBaseFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetProductGroupsRequest({ payload, cb }) { 
  const { entityType, entityId, size, page } = payload

  try {
    const res = yield axios.get(`/api/product/group?entityType=${entityType}&entityId=${entityId}&size=${size||10}&page=${page||0}`);
    yield put(HitClub.onGetProductGroupsSuccess({ data: res.data, entityId: entityId, entityType: entityType }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetProductGroupsFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateHitEventProductGroupRequest({ payload, cb }) { 

  try {
    const res = yield axios.post(`/api/product/createProductGroup`, payload);
    yield put(HitClub.onCreateHitEventProductGroupSuccess({ data: res.data, entityId: payload.entityId, entityType: payload.entityType }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onCreateHitEventProductGroupFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onEditHitEventProductGroupRequest({ payload, cb }) { 
  try {
    const res = yield axios.post(`/api/product/updateProductGroup`, payload);
    yield put(HitClub.onEditHitEventProductGroupSuccess({ data: res.data, entityId: payload.entityId, entityType: payload.entityType }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onEditHitEventProductGroupFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onRemoveHitEventProductGroupRequest({ payload, cb }) { 

  try {
    const res = yield axios.post(`/api/product/group/delete`, { productGroupId: payload.productGroupId });
    yield put(HitClub.onRemoveHitEventProductGroupSuccess({ productGroupId: payload.productGroupId, hitEventId: payload.hitEventId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onRemoveHitEventProductGroupFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitEventProductGroupOffersRequest({ payload, cb }) { 
  const { productGroupId, size, page } = payload

  try {
    const res = yield axios.get(`/api/product/web/offer/productGroup/${productGroupId}?size=${size||10}&page=${page||0}`);
    yield put(HitClub.onGetHitEventProductGroupOffersSuccess({ data: res.data, productGroupId: productGroupId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onGetHitEventProductGroupOffersFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitEventProductOfferRequest({ payload, cb }) { 
  const { productOfferId, productGroupId } = payload

  try {
    const res = yield axios.get(`/api/product/offer/${productOfferId}/edit`);
    yield put(HitClub.onGetHitEventProductOfferSuccess({ data: res.data, productGroupId: productGroupId, productOfferId: productOfferId }));

    cb && cb(null, res);
  } catch (e) {
    yield put(HitClub.onGetHitEventProductOfferFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateHitEventProductOfferRequest({ payload, cb }) { 

  try {
    const res = yield axios.post(`/api/product/createProductOffer`, payload);
    yield put(HitClub.onCreateHitEventProductOfferSuccess({ data: res.data, productGroupId: payload.productGroup.productGroupId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onCreateHitEventProductOfferFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onEditHitEventProductOfferRequest({ payload, cb }) { 

  try {
    const res = yield axios.post(`/api/product/updateProductOffer`, payload);
    yield put(HitClub.onEditHitEventProductOfferSuccess({ data: res.data, productGroupId: payload.productGroup.productGroupId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onEditHitEventProductOfferFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onRemoveHitEventProductOfferRequest({ payload, cb }) { 

  const { productOfferId } = payload

  try {
    const res = yield axios.post(`/api/product/offer/delete`, { productOfferId : productOfferId });
    yield put(HitClub.onRemoveHitEventProductOfferSuccess({ productGroupId: payload.productGroupId, productOfferId: payload.productOfferId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitClub.onRemoveHitEventProductOfferFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitEventTicketsRequest({ payload, cb }) {
  const { hitEventId, page, size, q } = payload;

  try {
    const res = yield axios.get(`/api/product/offer/search?entityType=HIT_EVENT&entityId=${hitEventId}&productType=TICKET&page=${page || 0}&size=${size || 10}`);
    yield put(HitClub.onGetHitEventTicketsSuccess({ data: res.data, hitEventId: hitEventId }));
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onGetHitEventTicketsFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}

export function* onGetEditProductOfferInformationRequest({ payload, cb }) {

  const { productGroupId, entityType, entityId } = payload

  try {
      const rs = yield axios.get(`/api/product/group/${productGroupId}/edit`);

      yield put(HitClub.onGetEditProductOfferInformationSuccess({ data: rs.data, productGroupId: productGroupId, entityId: entityId, entityType: entityType } || {}));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetEditProductOfferInformationRequest', e);
      yield put(HitClub.onGetEditProductOfferInformationFailure());
      cb && cb(e);
  }
}

export function* onGetElectionPostsRequest({ payload, cb }) {

  try {
      const rs = yield axios.get(`/api/election/hitEvent/electionPosts/${payload.hitEventId}`);

      yield put(HitClub.onGetElectionPostsSuccess({ data: rs.data, hitEventId: payload.hitEventId }));

      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onCreateElectionPostRequest', e);
      yield put(HitClub.onGetElectionPostsFailure());
      cb && cb(e);
  }
}

export function* onCreateElectionPostRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/createElectionPost`, payload);

      yield put(HitClub.onCreateElectionPostSuccess({ data: rs.data, hitEventId: payload.hitEvent.hitEventId }));
      toastr.success(i18n.t('toastr.onCreateElectionPostSuccess.title'), i18n.t('toastr.onCreateElectionPostSuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onCreateElectionPostRequest', e);
      yield put(HitClub.onCreateElectionPostFailure());
      cb && cb(e);
  }
}

export function* onUpdateElectionPostRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/updateElectionPost`, payload);

      yield put(HitClub.onUpdateElectionPostSuccess({ data: rs.data, hitEventId: payload.hitEvent.hitEventId }));
      toastr.success(i18n.t('toastr.onUpdateElectionPostSuccess.title'), i18n.t('toastr.onUpdateElectionPostSuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onUpdateElectionPostRequest', e);
      yield put(HitClub.onUpdateElectionPostFailure());
      cb && cb(e);
  }
}

export function* onRemoveElectionPostRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/deleteElectionPost`, { "electionPostId": payload.electionPostId });

      yield put(HitClub.onRemoveElectionPostSuccess({ data: rs.data, hitEventId: payload.hitEventId }));
      toastr.success(i18n.t('toastr.onRemoveElectionPostSuccess.title'), i18n.t('toastr.onRemoveElectionPostSuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onRemoveElectionPostRequest', e);
      yield put(HitClub.onRemoveElectionPostFailure());
      cb && cb(e);
  }
}

export function* onMoveElectionPostRequest({ payload, cb }) {

  let data = payload.arrayAfterMove.map(function (electionPost, index) {
    return { 
      electionPostId: electionPost.electionPostId,
      position: index
    };
  })

  try {
      const rs = yield axios.post(`/api/election/electionPost/setPosition`, data);

      yield put(HitClub.onMoveElectionPostSuccess({ data: payload.arrayAfterMove, hitEventId: payload.hitEventId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onMoveElectionPostRequest', e);
      yield put(HitClub.onMoveElectionPostFailure());
      cb && cb(e);
  }
}

export function* onGetElectionCandidaciesRequest({ payload, cb }) {

  try {
      const rs = yield axios.get(`/api/election/electionPost/candidates/${payload.electionPostId}`);

      yield put(HitClub.onGetElectionCandidaciesSuccess({ data: rs.data, electionPostId: payload.electionPostId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetElectionCandidaciesRequest', e);
      yield put(HitClub.onGetElectionCandidaciesFailure());
      cb && cb(e);
  }
}

export function* onCreateElectionCandidacyRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/createCandidate`, payload);

      yield put(HitClub.onCreateElectionCandidacySuccess({ data: rs.data, electionPostId: payload.electionPost.electionPostId }));
      toastr.success(i18n.t('toastr.onCreateElectionCandidacySuccess.title'), i18n.t('toastr.onCreateElectionCandidacySuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onCreateElectionPostRequest', e);
      yield put(HitClub.onCreateElectionCandidacyFailure());
      cb && cb(e);
  }
}

export function* onUpdateElectionCandidacyRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/updateCandidate`, payload);

      yield put(HitClub.onUpdateElectionCandidacySuccess({ data: rs.data, electionPostId: payload.electionPost.electionPostId }));
      toastr.success(i18n.t('toastr.onUpdateElectionCandidacySuccess.title'), i18n.t('toastr.onUpdateElectionCandidacySuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onUpdateElectionCandidacyRequest', e);
      yield put(HitClub.onUpdateElectionCandidacyFailure());
      cb && cb(e);
  }
}

export function* onRemoveElectionCandidacyRequest({ payload, cb }) {

  try {
      const rs = yield axios.post(`/api/election/deleteCandidate`, {
        "candidateId": payload.candidateId
      });

      yield put(HitClub.onRemoveElectionCandidacySuccess({ data: rs.data, electionPostId: payload.electionPostId }));
      toastr.success(i18n.t('toastr.onRemoveElectionCandidacySuccess.title'), i18n.t('toastr.onRemoveElectionCandidacySuccess.body'))
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onRemoveElectionCandidacyRequest', e);
      yield put(HitClub.onRemoveElectionCandidacyFailure());
      cb && cb(e);
  }
}

export function* onMoveElectionCandidacyRequest({ payload, cb }) {

  let data = payload.arrayAfterMove.map(function (candidate, index) {
    return { 
      candidateId: candidate.candidateId,
      position: index
    };
  })

  try {
      const rs = yield axios.post(`/api/election/candidate/setPosition`, data);

      yield put(HitClub.onMoveElectionCandidacySuccess({ data: payload.arrayAfterMove, candidateId: payload.candidateId, electionPostId: payload.electionPostId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onMoveElectionCandidacyRequest', e);
      yield put(HitClub.onMoveElectionCandidacyFailure());
      cb && cb(e);
  }
}

export function* onGetHitEventElectionResultRequest({ payload, cb }) {

  try {
      const rs = yield axios.get(`/api/election/hitEvent/${payload.hitEventId}/results`);

      yield put(HitClub.onGetHitEventElectionResultSuccess({ data: rs.data, hitEventId: payload.hitEventId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetHitEventElectionResultRequest', e);
      yield put(HitClub.onGetHitEventElectionResultFailure());
      cb && cb(e);
  }
}

export function* onGetElectionPostResultRequest({ payload, cb }) {
  const { electionPostId, page, size } = payload

  try {
      const rs = yield axios.get(`/api/election/electionPost/${electionPostId}/results?page=${page || 0}&size=${size || 10}`);
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetElectionPostResultRequest', e);
      yield put(HitClub.onGetElectionPostResultFailure());
      cb && cb(e);
  }
}

export function* onMoveMembershipRequest({ payload, cb }) {

  let data = payload.arrayAfterMove.map(function (membership, index) {
    return { 
      membershipOfferId: membership.membershipOfferId,
      position: index
    };
  })
  
  try {
      const rs = yield axios.post(`/api/membership/setPosition`, data);

      yield put(HitClub.onMoveMembershipSuccess({ data: payload.arrayAfterMove, hitClubId: payload.hitClubId }));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onMoveMembershipRequest', e);
      yield put(HitClub.onMoveMembershipFailure());
      cb && cb(e);
  }
}

export function* onCreateMembersReportRequest({ params, cb }) {
  try {
    const res = yield axios.post(`/api/hitMember/${params.hitClubId}/excel`, {
      fromDate: format(setHours(setSeconds(params.fromDate, 0), 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}),
      toDate: params.toDate != null ? format(setHours(setSeconds(params.toDate, 0), 0), "yyyy-MM-dd HH:mm:ss", {locale: i18n.language === "sv" ? sv : enUS}) : null,
      fields: params.fields
    },{responseType:'blob'});
    if(!res.data.size) {
      toastr.success(i18n.t('toastr.onCreateMembersReportSuccess.title'), i18n.t('toastr.onCreateMembersReportSuccess.body'))
    } 
    cb && cb(null, res.data);
  } catch (e) {
    yield put(HitClub.onCreatePayoutReportFailure({ message: e.toString(), error: e }));
    toastr.error(i18n.t('toastr.onCreateMembersReportFailure.title'), i18n.t('toastr.onCreateMembersReportFailure.body'))
    cb && cb(e);
  }
}

export function* onGetHitClubActiveStudentsDebouncedRequest({ payload, cb }) { 
  try {
    const rs = yield axios.post(`/api/hitClub/getLadokMember`, payload);
    cb && cb(null, rs);
  } catch (e) {
    cb && cb(e);
  }
}

export function* onGetActiveSubMembershipsRequest({ payload, cb }) {
  const { hitMemberId, page, size } = payload
  try {
      const rs = yield axios.get(`/api/hitMember/${hitMemberId}/activeSubMemberships?page=${page || 0}&size=${size || 10}`);
      yield put(HitClub.onGetActiveSubMembershipsSuccess({ data: (rs.data || {}), hitMemberId: hitMemberId } || {}));
      cb && cb(null, rs);
  } catch (e) {
      console.log('Error: onGetActiveSubMembershipsRequest', e);
      yield put(HitClub.onGetActiveSubMembershipsFailure());
      cb && cb(e);
  }
}
